import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useNavigate } from 'react-router-dom';

import Works from '../data/works.json';
import 'swiper/css';
import 'swiper/css/navigation'; // スタイルをインポート
import 'swiper/css/pagination'; // スタイルをインポート


export const Slider = (props) => {
    const { ua } = props;
    const navigate = useNavigate();

    const updateTitle = (name, type) => {
        props.updateLast(name, type);
    }

    const getLinkDict = (ww) => {
        let d = {};
        d['name'] = ww.id;
        d['link'] = (ww.outerLink === undefined ? "/works/" + ww.id : ww.outerLink);
        d['type'] = (ww.outerLink === undefined ? "in" : "out");
        return d;
    }

    const jumpContent = (name) => {
        let researchList = Works.jp.research.map((w, i) => {
            return (w.contents.map((ww, i) =>
                getLinkDict(ww)
            ))
        }).flat();
        let productList = Works.jp.product.map((p, i) => getLinkDict(p));
        const lists = researchList.concat(productList);
        const linkDict = lists.reduce((obj, x) => Object.assign(obj, { [x.name]: { link: x.link, type: x.type } }), {});

        const nowLink = linkDict[name];
        if (nowLink.type === 'in') {
            navigate(nowLink.link, { state: { id: name, lang: props.lang } });
        } else {
            window.open(nowLink.link);//, '_blank', 'noreferrer');
        }
    }

    return (
        <Swiper
            spaceBetween={ua === "sp" ? 30 : -50}
            slidesPerView={3}
            modules={[Navigation, Pagination]}
            navigation
            pagination={{ clickable: true }}>
            {props.data.map((l, i) => {
                return (
                    <SwiperSlide key={"l_" + i}>
                        <div
                            onMouseEnter={() => updateTitle(l.title, l.type)}
                            onMouseLeave={() => updateTitle("", "in")}
                            onClick={() => jumpContent(l.img)}
                            className={ua === "sp" ? "last-work-sp" : "last-work"}
                            style={{ backgroundImage: ('url("/works/' + l.img + '/top.jpg")') }} alt="" /></SwiperSlide>);
            })}
        </Swiper>
    );
};
